module.exports = __webpack_public_path__ + "static/media/bell-icon.a3aee063.svg";